import React, { useEffect, useState } from "react";
import { useParams, useLocation, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { servicesData } from "../data/servicesData";
import "../styles/servicepage.css";

const ServicePage = () => {
  const { slug } = useParams();
  const location = useLocation();

  const service = servicesData.find((s) => s.slug === slug);

  /* ---------------- HERO IMAGE PRELOAD STATE ---------------- */
  const [heroLoaded, setHeroLoaded] = useState(false);

  /* ---------------- HERO IMAGE SELECTION ---------------- */
  const heroImage =
    window.innerWidth < 768 && service?.hero?.imageMobile
      ? service.hero.imageMobile
      : service?.hero?.image;

  /* ---------------- IMAGE PRELOAD ---------------- */
  useEffect(() => {
    if (!heroImage) return;

    const img = new Image();
    img.src = heroImage;
    img.onload = () => setHeroLoaded(true);
  }, [heroImage]);

  /* ---------------- HASH SCROLL ---------------- */
  useEffect(() => {
    if (!service) return;

    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location, service]);

  /* ---------------- REDIRECT ---------------- */
  if (!service) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      {/* ================= SEO + PRELOAD ================= */}
      <Helmet>
        <title>{service.seo.title}</title>
        <meta name="description" content={service.seo.description} />
        <link rel="canonical" href={service.seo.canonical} />

        {/* HERO IMAGE PRELOAD */}
        {heroImage && (
          <link
            rel="preload"
            as="image"
            href={heroImage}
            fetchpriority="high"
          />
        )}
      </Helmet>

      {/* ================= HERO ================= */}
      <section
        className={`service-hero text-center ${heroLoaded ? "loaded" : ""}`}
        style={{
          backgroundImage: heroLoaded ? `url("${heroImage}")` : "none",
        }}
      >
        <div className="overlay"></div>

        <div className="container">
          <h1 className="service-hero-title">{service.hero.title}</h1>
          <p className="service-hero-subtext">{service.hero.subtitle}</p>
          <a href="#contact" className="btn">
            Időpontfoglalás
          </a>
        </div>
      </section>

      {/* ================= CONTENT ================= */}
      <div className="service-page container py-5">
        {service.section && (
          <>
            <h2 className="section-title">{service.section.title}</h2>
            <div className="title-underline mb-4"></div>

            {service.section.paragraphs.map((text, i) => (
              <p key={i} className="service-subtext">
                {text}
              </p>
            ))}
          </>
        )}

        {service.prices.map((group, i) => (
          <div id="prices" className="price-box mb-5" key={i}>
            <h2 className="price-category">{group.category}</h2>
            <ul className="price-list">
              {group.items.map((item, j) => (
                <li key={j}>
                  <span>{item.name}</span>
                  <span>{item.price}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </>
  );
};

export default ServicePage;
